import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import SpaceOwnerProfileStore from "../../stores/SpaceOwnerProfileStore";
import ShareableContactInformationView from "../views/ShareableContactInformationView";
import LoadingView from "../views/LoadingView";

class SpaceOwnerProfileContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "spaceOwnerProfileStore": SpaceOwnerProfileStore.getState(),
        }
    }

    componentDidMount() {
        this.spaceOwnerProfileStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.SPACE_OWNER_PROFILE_STORE_UPDATE, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.SPACE_OWNER_PROFILE_VIEW_MOUNTED, {"spaceId" :this.props.match.params.id})
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.spaceOwnerProfileStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.SPACE_OWNER_PROFILE_UNMOUNT, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "spaceOwnerProfileStore": SpaceOwnerProfileStore.getState(),
        });
    };

    render() {
        if (this.state.spaceOwnerProfileStore.loadingState === LoadingStates.INITIALIZED) {
            return (
                <LoadingView titleText="Loading Space Owner"/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <ShareableContactInformationView
                            displayName={this.state.spaceOwnerProfileStore.displayName}
                            phoneNumber={this.state.spaceOwnerProfileStore.phoneNumber}
                            about={this.state.spaceOwnerProfileStore.about}
                            email={this.state.spaceOwnerProfileStore.email}
                            header={"Space Owner Contact Information"}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default SpaceOwnerProfileContainer;